import { apiClient } from '../../services/api';

/**
 * Get all clients (attorney view)
 */
export async function getClients(options = {}) {
  const params = new URLSearchParams();
  if (options.search) params.append('search', options.search);
  if (options.status) params.append('status', options.status);
  if (options.assignmentFilter) params.append('assignmentFilter', options.assignmentFilter);

  const queryString = params.toString();
  const url = queryString ? `/attorney/clients?${queryString}` : '/attorney/clients';

  const response = await apiClient.get(url);
  return response.data;
}

/**
 * Get a single client with their applications
 */
export async function getClient(clientId) {
  const response = await apiClient.get(`/attorney/clients/${clientId}`);
  return response.data;
}

export default {
  getClients,
  getClient
};
